export default "<div class=\"loading\">\r\n  <div></div>\r\n</div>\r\n";